const deliveryNoteApiErrorMappings = {
  note: {
    'value is not unique': 'Sudah terdaftar di sistem.'
  }
}

export default deliveryNoteApiErrorMappings